import { Component, OnInit } from '@angular/core';
import { ValidaService } from './valida.service';
import { Subject } from 'rxjs/Rx';


@Component({
  selector: 'cm-valida-documentos',
  templateUrl: './valida-documentos.component.html',
  styleUrls: ['./valida-documentos.component.scss']
})
export class ValidaDocumentosComponent implements OnInit {
   

  cpf = 0;

  configuracao = new Subject()

  query = {
    search: null,
    page: 1,
  };

  total: Number;
  porPagina: Number;
  loading: boolean;
  validas: Array<any> = new Array();
  alunosPaginados: Array<any> = new Array();
  paginas:any;
  paginaAtual:any;
  quantidade=100;
  bold = true;

  constructor(
    private validaService: ValidaService,   
    ) {}

  ngOnInit() {
    this.listarAlunos();
  }

  listarAlunos(){
     this.validaService.listarAlunos().subscribe(validas => {
        this.validas = validas;
        this.loading = true;
        //Dividir o número de alunos pelo número que cada página deve ter (40)
        //O resulado é o número de páginas +1
        this.paginas = Math.ceil(this.validas.length/this.quantidade);
        this.buscaAlunos(1);
        this.loading = false;
     }, err => {
       console.log("Erro ao listar os alunos", err);
     })
  }
  
  
  mostrarDados(cpf){
    this.cpf = cpf;
  }

  //Busca página de alunos
  buscaAlunos(pagina){
    let alunosPaginados:Array<any> = new Array;
    let i:any = 0;
    for(i=this.quantidade*(pagina-1);i<this.quantidade*pagina;i++){
      if(this.validas[i]!=undefined)
        alunosPaginados.push(this.validas[i]);
    }
    this.paginaAtual = pagina;
    this.alunosPaginados = alunosPaginados;
  }

  arrayOne(n: number): any[] {
    return Array(n);
  }

  //Buscando o aluno pelo nome, codigo conclusao e codigo verificacao
  acaoBuscar() {
    let alunosPaginados:Array<any> = new Array;
    let pesquisa = this.query.search;
    this.validas.forEach(function (value){
      let digitado = value.aluno + value.curso + value.conclusao + value.codigo_verificacao;
      if(digitado.toUpperCase().indexOf(pesquisa.toUpperCase()) > -1){
        alunosPaginados.push(value);
      }
    });
    this.alunosPaginados = alunosPaginados;
  }
}
